/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Allow_Buyers_To_Make_OffersInputs */

const en_allow_buyers_to_make_offers = /** @type {(inputs: Allow_Buyers_To_Make_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow buyers to make offers`)
};

const es_allow_buyers_to_make_offers = /** @type {(inputs: Allow_Buyers_To_Make_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permitir que los compradores hagan ofertas`)
};

const fr_allow_buyers_to_make_offers = /** @type {(inputs: Allow_Buyers_To_Make_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autoriser les acheteurs à faire des offres`)
};

const de_allow_buyers_to_make_offers = /** @type {(inputs: Allow_Buyers_To_Make_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käufern erlauben, Angebote zu machen`)
};

const ja_allow_buyers_to_make_offers = /** @type {(inputs: Allow_Buyers_To_Make_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入者からの価格交渉を許可する`)
};

const zh_allow_buyers_to_make_offers = /** @type {(inputs: Allow_Buyers_To_Make_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`允许买家出价`)
};

const ar_allow_buyers_to_make_offers = /** @type {(inputs: Allow_Buyers_To_Make_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السماح للمشترين بتقديم عروض`)
};

const id_allow_buyers_to_make_offers = /** @type {(inputs: Allow_Buyers_To_Make_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izinkan pembeli mengajukan penawaran`)
};

const it_allow_buyers_to_make_offers = /** @type {(inputs: Allow_Buyers_To_Make_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consenti agli acquirenti di fare offerte`)
};

const ru_allow_buyers_to_make_offers = /** @type {(inputs: Allow_Buyers_To_Make_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разрешить покупателям предлагать свою цену`)
};

const pt_allow_buyers_to_make_offers = /** @type {(inputs: Allow_Buyers_To_Make_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permitir que compradores façam ofertas`)
};

const ko_allow_buyers_to_make_offers = /** @type {(inputs: Allow_Buyers_To_Make_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매자가 가격을 제안하도록 허용`)
};

/**
* | output |
* | --- |
* | "Allow buyers to make offers" |
*
* @param {Allow_Buyers_To_Make_OffersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const allow_buyers_to_make_offers = /** @type {((inputs?: Allow_Buyers_To_Make_OffersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Allow_Buyers_To_Make_OffersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_allow_buyers_to_make_offers(inputs)
	if (locale === "es") return es_allow_buyers_to_make_offers(inputs)
	if (locale === "fr") return fr_allow_buyers_to_make_offers(inputs)
	if (locale === "de") return de_allow_buyers_to_make_offers(inputs)
	if (locale === "ja") return ja_allow_buyers_to_make_offers(inputs)
	if (locale === "zh") return zh_allow_buyers_to_make_offers(inputs)
	if (locale === "ar") return ar_allow_buyers_to_make_offers(inputs)
	if (locale === "id") return id_allow_buyers_to_make_offers(inputs)
	if (locale === "it") return it_allow_buyers_to_make_offers(inputs)
	if (locale === "ru") return ru_allow_buyers_to_make_offers(inputs)
	if (locale === "pt") return pt_allow_buyers_to_make_offers(inputs)
	return ko_allow_buyers_to_make_offers(inputs)
});